import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const createUserRequest = () => {
    return {
        data: null,
        error: null,
        loading: true,
    }
};

const createUserSuccess = ( state, action ) => {
    return {
        data: action.data,
        error: null,
        loading: false,
    }
};

const createUserFail = ( state, action ) => {
    return {
        data: null,
        error: action.error,
        loading: false,
    }
};

const clearUserErrors = ( state ) => {
    return {
        ...state,
        error: null
    }
};

export const userReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.CREATE_USER_REQUEST: return createUserRequest();
        case actionTypes.CREATE_USER_SUCCESS: return createUserSuccess(state, action);
        case actionTypes.CREATE_USER_FAIL: return createUserFail(state, action);
        case actionTypes.CLEAR_ALL_ERRORS: return clearUserErrors(state);
        default:
            return state;
    }
};